import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {path: '/', name: 'dashboard', component: Home},
  {path: '/history', name: 'history', component: () => import('../views/History.vue')},
  {path: '/cashbox/payment', name: 'payment', component: () => import('../views/cashbox/Payment.vue')},
  {path: '/cashbox/employee/:id', name: 'employee',  component: () => import('../views/cashbox/Employee.vue')},
  {path: '/cashbox/organization/:id', name: 'organization', component: () => import(
    '../views/cashbox/Organization.vue'
  )},
  {path: '/employees', name: 'employees', component: () => import('../views/Employees.vue')},
  {path: '/organizations', name: 'organizations', component: () => import('../views/Organizations.vue')},
  // {path: '/customers', name: 'customers', component: () => import('../views/Customers.vue')},
  {path: '/settings', name: 'settings', component: () => import('../views/Settings.vue')},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
